<template>
  <v-dialog
    v-model="showDialog"
    persistent
    scrollable
    :fullscreen="$vuetify.display.xs"
    :width="$vuetify.display.smAndUp ? 600 : 'auto'"
    style="z-index: 1100 !important;"
  >

    <v-card class="vb-select-folder-card" data-cy="dialog---">
      <v-card-title class="d-flex justify-space-between" data-cy="dialog---">
        {{$t('routes.users.addAccessPoint')}}

        <v-btn icon @click="close">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text scrollable  class="scrollable mt-2 pb-0">
        <div>{{ $t('routes.users.confirmAccesspointAdd') }}</div>

        <!-- <div v-show="successMessage" class="success" data-cy="dialog-createTranscript-successMessage">{{successMessage}}</div> -->
        <div v-show="errorMessage" class="bg-error" data-cy="dialog-createTranscript-errorMessage">{{errorMessage}}</div>
        <div v-if="errorTranslatable" class="bg-error">
          {{$replaceT(errorTranslatable.code, errorTranslatable.params, errorTranslatable.content)}}
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          @click="addAccessPoint"
          :disabled="addButtonDisabled"
          class="bg-primary"
          elevation="0"
          data-cy="dialog---"
        >
          {{$t('common.add')}}
        </v-btn>
        <v-btn variant="text" @click="close" data-cy="dialog---">{{$t('common.cancel')}}</v-btn>
      </v-card-actions>
    </v-card>

  </v-dialog>
</template>

<script>
import { useUserStore } from '@/stores/UserStore.js'
import DialogActionKeys from '@/components/mixin/DialogActionKeys.js';

export default {
  emits: ["dialogClosed", 'update:modelValue'],
  mixins: [DialogActionKeys],
  name: "AccesspointAddDialog",

  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    user: {
      type: Object,
      required: true,
    },
    nodeId: {
      type: String,
      required: true,
    }
  },

  data() {
    return {
      // dialog: false,
      errorMessage: '',
      errorTranslatable: null,
      addButtonDisabled: false,
    };
  },

  watch: {
    showDialog(newValue) {
      if (newValue) {
        this.resetDialog();
      }
    }
  },

  methods: {
    resetDialog() {
      this.errorMessage = '';
      this.errorTranslatable = null;
      this.addButtonDisabled = false;
    },
    close() {
      this.showDialog = false;
      this.$emit('dialogClosed', true);
    },
    addAccessPoint() {
      this.addButtonDisabled = true;

      let self = this;
      const payload = {
        userid: this.user.id,
        nodeid: this.nodeId,
      };

      const userStore = useUserStore();
      userStore.addAccesspoint(payload)
      .then(function() {
        self.close();
      })
      .catch(function(error) {
        if (error && error.response && error.response.data && error.response.data.error) {
          const apiError = error.response.data.error.message;
          if (typeof apiError == 'object') {
            self.errorTranslatable = apiError;
          } else {
            self.errorMessage = apiError;
          }
        } else {
          self.errorMessage = "Error!";
          console.log(error);   // unhandled error
        }
      });
    }
  },

  computed: {
    showDialog: {
      get () {
        return this.modelValue;
      },
      set (value) {
        this.$emit('update:modelValue', value);
      }
    }
  }
};
</script>
